import config from '../config';
import Transition from './Transition';
import Knight from './Play/Knight';
import MPUtils from '../mp/MPUtils';

let dataManager;
let soundManager;
let apiManager;
let FPS;
let waveReached;

class EndScore extends Phaser.Scene {
  init (data) {
    let g = this;
    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');
    apiManager = g.sys.game.apiManager;

    dataManager.setSessionItem(config.BASE_SCENE, 'EndScore');

    FPS = 1000 / g.sys.game.loop.targetFps;
    waveReached = data.wave;
    // console.log('EndScore.init');
  }
  create () {
    // console.log('end create');
    let g = this;

    let score = dataManager.getScore();

    // let floor = data.wave;
    let floor = dataManager.getSessionItem('lastFloor');

    let bg = g.add.image(config.CENTER_X, config.CENTER_Y, 'end-bg');
    let gameOver = g.add.image(config.CENTER_X, 175, 'end-game-over');

    const textStyle = { fontFamily: g.game.localis.mainFont, fontSize: 66 +"px", color: "#ffffff",
      stroke: "#000000", strokeThickness: Math.ceil(11) };
    const title = g.add.text(config.CENTER_X, 126, g.game.localis.GetString("game_over").toLocaleUpperCase(g.game.localis.language), textStyle);
    title.setOrigin(0.5);
    MPUtils.ClampTextToDimensions(title, 420, 180);

    const subTextStyle = { fontFamily: g.game.localis.mainFont, fontSize: 24 +"px", color: "#ffffff" };
    const subTitle = g.add.text(config.CENTER_X, 182, g.game.localis.GetString("final_score").toLocaleUpperCase(g.game.localis.language), subTextStyle);
    subTitle.setOrigin(0.5);

    let knight = new Knight(g);

    g.settingsButton = g.add.sprite(config.WIDTH - 10, 10, 'common', 'settings-button.png');
    g.settingsButton.setOrigin(1, 0);
    g.settingsButton.setInteractive();
    g.settingsButton.on('pointerdown', g.onSettingsClicked, g);

    let scoreText = g.add.bitmapText(config.CENTER_X, 235, 'ocr45', score.toLocaleString(), 45);
    scoreText.setCenterAlign();
    scoreText.setOrigin(0.5);

    let highScore = dataManager.getHighScore();
    g.add.sprite(config.CENTER_X, 757, 'common', 'end-best-label.png');
    let highScoreText = g.add.bitmapText(config.CENTER_X, 775, 'ocr30', highScore.toLocaleString(), 30);
    highScoreText.setCenterAlign();
    highScoreText.setOrigin(0.5);

    const bestLabel = g.add.text(config.CENTER_X, 728, g.game.localis.GetString("best").toLocaleUpperCase(g.game.localis.language), subTextStyle);
    bestLabel.setOrigin(0.5);

    const floorText = g.add.text(config.CENTER_X, 300, g.game.localis.GetString("end_floor").replace("<num>", floor).toLocaleUpperCase(g.game.localis.language), subTextStyle);
    floorText.setOrigin(0.5);

    // add play button from the sprite sheet first frame
    // let playButton = g.add.sprite(config.CENTER_X, 900, 'common', 'play-button.png');
    let playButton = g.add.sprite(config.CENTER_X, 900, 'ui-animation');
    playButton.play('play-btn');
    playButton.setInteractive({ useHandCursor: true });
    playButton.once('pointerdown', g.playButtonClicked, g, true);

    this.transition = new Transition(g);
    this.transition.out(() => {
      knight.hover();
    });

    soundManager.playMusic('loop-end');

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On EndScore Resume');
      soundManager.resumeMusic();
    });
  }

  playButtonClicked () {
    let g = this;
    apiManager.trackGameStart();
    soundManager.playSound('play-btn');
    // soundManager.playSound('ben-replay');
    this.transition.in(() => {
      g.scene.start('Play');
    });
  }

  onSettingsClicked () {
    let g = this;
    g.scene.launch('SettingsPanel');
  }
}

export default EndScore;
